import React from 'react';
import { useMsal } from '@azure/msal-react';
import { LogOut } from 'lucide-react';

/**
 * LogoutButton component - handles user sign-out
 */
export const LogoutButton: React.FC = () => {
  const { instance } = useMsal();

  const handleLogout = async () => {
    try {
      await instance.logoutPopup({
        mainWindowRedirectUri: window.location.origin,
      });
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <button
      onClick={handleLogout}
      className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors"
    >
      <LogOut size={18} />
      Sign Out
    </button>
  );
};
